module.exports = __webpack_public_path__ + "static/img/wanDaContent1.0f76d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wanDaContent1.png
// module id = Tc+y
// module chunks = 2